<div class="main-container" *ngIf="!isUserDefined()">

  <div style="
    background:
      radial-gradient(circle at top right, rgba(236,139,93,0.10), transparent 35%),
      radial-gradient(circle at bottom left, rgba(20,39,78,0.08), transparent 35%),
      #fff;">

    <div class="container">
      <!-- Sign Up Section -->
      <!--<div class="d-flex justify-content-center align-items-center flex-column">
        <div class="row sign-up-link" style="margin-top: 20px;">
          <button
            class="btn"
            style="text-decoration: underline; color: #14274E; background-color: #FFF; font-size: 25px; font-family: 'Nunito-B'"
            (click)="onClickSignUpEndUser()"
          >
            SignUp
          </button>
          <p style="margin-top: 20px; color: #EC8B5D; font-size: 25px; font-family: 'Nunito-B';">for Booking</p>
        </div>
      </div>-->

      <!-- Popular Venues -->
      <div class="section-spacing fade-up">
        <div class="row align-items-center mb-4">
          <div class="col-6">
            <p class="popular-venues-heading">
              Explore Popular Venues
            </p>
          </div>
          <div class="col-6 text-end">
            <span class="more-venues-link d-none d-md-inline"
                  (click)="navigateToBusinesses()">
              More Venues →
            </span>

            <span class="more-venues-mobile d-inline d-md-none"
                  (click)="navigateToBusinesses()">
              →
            </span>
          </div>
        </div>
        <div class="tenant-scroll-row d-flex">
          <div class="tenant-card-home"
               *ngFor="let tenant of rowData"
               (click)="productDetails(tenant.id)">
            <ng-container *ngIf="tenantImagesObj[tenant.id]?.length > 0; else noImageBlock">
              <img [src]="tenantImagesObj[tenant.id][0]?.image"
                   class="tenant-home-image"
                   alt="Venue Image" />
            </ng-container>
            <ng-template #noImageBlock>
              <img src="../assets/img/noImage.png"
                   class="tenant-home-image"
                   alt="No Image" />
            </ng-template>
            <div class="tenant-home-details">
              <div class="tenant-home-name">{{ tenant.tenantName }}</div>

              <div class="tenant-home-address">
                {{ tenant.address?.addressLine1 }}
              </div>

              <div class="tenant-home-city">
                {{ tenant.address?.city }}
              </div>

              <div class="tenant-home-services">

                <img *ngFor=" let icon of tenantServiceIcons[tenant.id]"
                  [src]="icon"
                  class="service-icon"
                  alt="Service"
                />

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Auto Image Slider -->
      <div class="section-spacing fade-up">
        <div class="row align-items-center section-card booking-intro">
          <!-- Text Left -->
          <div class="col-12 col-xl-5 d-flex flex-column align-items-center align-items-xl-start text-xl-start">
            <h3 class="boldStatements mobile-align">
              Book Sports Venues, Find Trainers Near You.
              <span style="color: #EC8B5D;">Smartly</span>
            </h3>
            <p class="description mobile-align">
              India’s Smart Booking Platform.
            </p>
          </div>

          <!-- Image Right -->
          <div class="col-12 col-xl-7 booking-intro-media">
            <div class="slider-container">
              <img
                [src]="sliderImages[currentSliderIndex]"
                class="slider-image"
                alt="BookingDexter Slider"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="section-divider"></div>

      <!-- Main Content Row: Adjusted for Desktop and Mobile -->
      <div class="section-spacing fade-up">
        <div class="row align-items-center section-card business-registration">
          <!-- Left Half: Text and Button -->
          <div class="col-12 col-xl-5 d-flex flex-column align-items-center align-items-xl-start text-xl-start">
            <h3 class="boldStatements mobile-align">
              Online Booking Platform for your
              <span style="color: #EC8B5D;">Venue and Services</span>
            </h3>
            <p class="description mobile-align">
              One stop solution to manage your Bookings
            </p>
            <button class="btn createNewButtonStyle" type="button" (click)="openRegisterBusinessModal()" style="margin-top: 20px;">
              Register your Business for Free
            </button>
            <div class="offer-card">

              <div class="offer-badge">
                LIMITED TIME OFFER
              </div>

              <div class="offer-title">
                Start Free Today
              </div>

              <div class="offer-item">
                ✅ Zero Setup Fee
              </div>

              <div class="offer-price">
                Only ₹5 per Slot*
              </div>

              <div class="offer-note">
                *Terms & Conditions apply.
              </div>

              <div class="offer-contact">
                📞 Call: <strong>8530078212</strong>
              </div>

            </div>

          </div>

          <!-- Right Half: Image (Hidden on Mobile) -->
          <!--<div class="col-md-7 d-none d-md-flex justify-content-center">
            <img
              class="small-image"
              src="../../assets/img/HomeImage.png"
              style="height: 350px; width: 603px; background-repeat: no-repeat; margin-top: 20px;"
            />
          </div>-->
          <!-- Right Half: Auto Slider -->
          <div class="col-12 col-xl-7 business-registration-media">
            <div class="slider-container-business">
                <img
                  [src]="platformSliderImages[currentPlatformSliderIndex]"
                  class="slider-image-business"
                  alt="Online Booking Platform"
                />
              <!--<div
                class="slider-image"
                [style.background-image]="'url(' + platformSliderImages[currentPlatformSliderIndex] + ')'"
              ></div>-->
            </div>
          </div>

          <div class="stats-heading-wrapper  " style="margin-top:40px;">

            <h3 class="stats-heading center">
              Trusted by Thousands Across India
            </h3>

           <!-- <p class="stats-subheading" style="text-align: center;">
              Growing rapidly with sports venues, trainers and businesses
            </p>-->

          </div>

          <div class="platform-stats-row" >

            <!--<div class="platform-stat-card">

              <div class="platform-stat-number ">
                {{ animatedUsersCount }}K+
              </div>

              <div class="platform-stat-label center">
                Users
              </div>

            </div>-->

            <div class="platform-stat-card">

              <div class="platform-stat-number">
                {{ animatedTransactionsCount }}
              </div>

              <div class="platform-stat-label center">
                Bookings
              </div>

            </div>

          </div>


        </div>
      </div>

<!--      <div class="section-divider"></div>

      &lt;!&ndash; Platform Statistics Section &ndash;&gt;

      <div class="section-spacing fade-up">

        <div class="section-card stats-main-section">

          <div class="stats-heading-wrapper">

            <h3 class="stats-heading">
              Trusted by Thousands Across India
            </h3>

            <p class="stats-subheading">
              Growing rapidly with sports venues, trainers and businesses
            </p>

          </div>

          <div class="platform-stats-row">

            <div class="platform-stat-card">

              <div class="platform-stat-number">
                {{ animatedUsersCount }}K+
              </div>

              <div class="platform-stat-label">
                Users
              </div>

            </div>

            <div class="platform-stat-card">

              <div class="platform-stat-number">
                {{ animatedTransactionsCount }}
              </div>

              <div class="platform-stat-label">
                Transactions
              </div>

            </div>

          </div>

        </div>

      </div>-->

      <div class="section-divider"></div>

      <!-- Business Types Section -->
      <div class="section-spacing fade-up">
        <div class="row">
          <div class="col">
            <h3 class="descriptionHeader text-center mt-5">Business Types</h3>
          </div>
        </div>


        <!-- Responsive Business Types layout -->
        <div class="row justify-content-center mt-4">
          <div
            class="col-6 col-sm-4 col-md-3 col-lg-2 text-center mb-4"
            (click)="navigateToBusinesses()"
            *ngFor="let business of businessTypes"
          >
            <img class="bdhover" [src]="business.icon" style="height: 70px; width: 70px;" />
            <p class="mt-2 font-weight-bold">{{ business.name }}</p>
          </div>
        </div>
      </div>

      <div class="section-divider"></div>

      <!-- Business Admin Features Section -->
      <div class="section-spacing fade-up">

        <div class="row">
          <div class="col">
            <h3 class="descriptionHeader text-center">
              Business Admin Features
            </h3>
          </div>
        </div>

        <div class="row justify-content-center mt-5">
          <div class="col-12 col-sm-6 col-xl-3 mb-4"
               *ngFor="let feature of businessFeatures">
            <div class="section-card feature-card h-100">
              <div class="d-flex align-items-center mb-4">
                <img [src]="feature.icon"
                     class="feature-icon" />
                <h5 class="feature-title">
                  {{ feature.title }}
                </h5>
              </div>

              <ul class="feature-list">
                <li *ngFor="let detail of feature.details">
                  {{ detail }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>

<div *ngIf="isUserDefined()">
  <div class="container">
    <div class="row">
      <!-- background-color: white; -->
      <div class="col-md-11" style="margin-top: 20px; margin-bottom: 20px;">
        <!-- <app-sign-up-success></app-sign-up-success> -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>


<!--<ng-template #content let-modal>
    <div class="modal-body">
      <div class="login-main-card">
        <button class="close-button"
                type="button"
                (click)="onCancelLogin()">
          ×
        </button>
            <div class="row justify-content-center">
                <div class="col-auto" style="padding-top: 20px; ">
                  <img class = "center" src="../assets/img/Logo.svg" alt="Lights" style="width: 45px;height: 45px;">
                </div>
            </div>

            <div class="row">
                <div class="col">
                  <div *ngIf="showSignUpForm" class="auth-page-container">
                    <form [formGroup]="signUpFormGroup" class="auth-form-container text-center">
                          <div class="row">
                            <div class="col" style="margin-top: 20px;">
                              <h1 style="font-size: 30px;color: #14274e; font-family: 'Nunito-B';">
                                Join Our Family
                              </h1>
                              <p style="font-size: 13px;color: #7c7575;height : 18px">
                                And be part of this amazing community
                              </p>
                            </div>
                          </div>
                            <div class="form-group">
                                <div style="margin-top: 10px;">
                                  <label for="first-name" style="float: left;font-size: 11px; color: #7c7575; font-weight: bold;">
                                    FIRST NAME
                                  </label>
                                  <input type="text" id="first-name" class="form-control" formControlName="firstNameFormControl" placeholder="First Name"
                                         class="form-control auth-input" />
                                  <div *ngIf="signUpFormControls.firstNameFormControl.hasError('required') && signUpFormControls.firstNameFormControl.touched" style="color: red; font-size: 14px;">
                                    First Name is required.
                                  </div>
                                </div>
                              <div style="margin-top: 5px;">
                                <label for="last-name" style="float: left; font-size: 11px; color: #7c7575; font-weight: bold;">
                                  LAST NAME
                                </label>
                                <input type="text" id="last-name" class="form-control" formControlName="lastNameFormControl" placeholder="Last Name"
                                       class="form-control auth-input" />
                                <div *ngIf="signUpFormControls.lastNameFormControl.hasError('required') && signUpFormControls.lastNameFormControl.touched" style="color: red; font-size: 14px;">
                                  Last Name is required.
                                </div>
                              </div>

                              <div style="margin-top: 5px;">
                                <label for="email-address" style="float: left;font-size: 11px; color: #7c7575; font-weight: bold;">
                                  EMAIL ADDRESS
                                </label>
                                <input type="text" id="email-address" class="form-control" formControlName="emailFormControl" placeholder="Email"
                                       class="form-control auth-input" />
                                <div *ngIf="signUpFormControls.emailFormControl.hasError('required') && signUpFormControls.emailFormControl.touched" style="color: red; font-size: 14px;">
                                  Email is required.
                                </div>
                                <div *ngIf="signUpFormControls.emailFormControl.hasError('email') && signUpFormControls.emailFormControl.touched" style="color: red; font-size: 14px;">
                                  Invalid email address.
                                </div>
                              </div>
                              <div style="margin-top: 5px;">
                                <label for="contact-number" style="float:left; font-size: 11px; color: #7c7575; font-weight: bold;">
                                  CONTACT NUMBER
                                </label>
                                &lt;!&ndash;<div>
                                  <label style="line-height: 41px; z-index: 99; position: absolute; margin-left: 10px;" for="contact-number">+91 - </label>
                                </div>&ndash;&gt;
                                <input type="text" id="contact-number" class="form-control" formControlName="phoneNoFormControl" placeholder="Phone Number" maxlength="10"
                                       class="form-control auth-input" />
                                <div *ngIf="signUpFormControls.phoneNoFormControl.hasError('required') && signUpFormControls.phoneNoFormControl.touched" style="color: red; font-size: 14px;">
                                  Phone Number is required.
                                </div>
                                <div *ngIf="signUpFormControls.phoneNoFormControl.hasError('pattern') && signUpFormControls.phoneNoFormControl.touched" style="color: red; font-size: 14px;">
                                  Invalid phone number. Must be 10 digits.
                                </div>
                              </div>
                              <div class="form-check" style="padding-top: 15px;">
                                <input type="checkbox" id="checkbox-login" class="form-check-input" formControlName="checkboxFormControl" style="width: 16px; height: 16px; margin-top: 7px;" />
                                <label class="form-check-label" for="checkbox-login" style="font-size: 14px; color: #7c7575; font-family: 'Nunito-B';">
                                  I have read and agreed to <br>
                                  <a routerLink="/terms">Terms &amp; Conditions</a> and
                                  <a routerLink="/privacy-policy">Privacy Policy</a>.
                                </label>
                                <div *ngIf="signUpFormControls.checkboxFormControl.hasError('required') && signUpFormControls.checkboxFormControl.touched" style="color: red; font-size: 14px;">
                                  You must agree to the terms and conditions.
                                </div>
                              </div>

                                <div *ngIf="userExistsError" style="margin-top: 10px; color: red;font-size: 14px;">
                                  User Email Address or Phone Number already exists.
                                </div>
                                <div style="margin-top: 20px;">
                                    <button class="btn btn-primary signin-btn" type="button" (click)="onGetStartedClicked()">
                                        Get Started
                                    </button>
                                </div>
                            </div>
                            <div class="auth-center" style="margin-top:30px;">
                              <p style="font-size: 14px; font-family: 'Nunito-B';">
                                Already Have an Account?  <a (click)="onShowSignInFormClicked()" style="cursor: pointer; color: #14274E; font-size: 20px; font-family: 'Nunito-B';"> Sign In</a>
                              </p>
                            </div>
                         </form>
                    </div>


                  <div *ngIf="showSignInForm">
                    <form [formGroup]="signInFormGroup" class="auth-form-container text-center">
                            <div class="form-group auth-form-container">
                              <div class="row auth-title">
                                <div style="margin-top:20px;">
                                  <h1 style="font-size:30px;color:#14274e;font-family:'Nunito-B';margin-bottom:0;">
                                    Sign In
                                  </h1>
                                </div>
                              </div>
                              <div style="margin-top: 20px;">
                                  <label style="float: left; font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="email-address">
                                      EMAIL ADDRESS
                                  </label>
                                  &lt;!&ndash; this is to avoid auto focus on first input element &ndash;&gt;
                                  <input type="text" style="display:none" />
                                  <input type="text" id="email-address" class="form-control auth-input" formControlName="emailFormControl" placeholder="Email"
                                      style=" height: 40px; padding-right: 5px;" />
                                  <div *ngIf="signInFormControls.emailFormControl.hasError('required') && signInFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                                      Email is required.
                                  </div>
                              </div>
                              <div style="margin-top: 15px;">
                                  <label style="float: left; font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="password">
                                      PASSWORD
                                  </label>
                                  <a (click)="onShowForgotPasswordFormClicked()" style="float: right; cursor: pointer; color: #14274E; font-size: 13px; font-family: 'Nunito-B';padding-right: 15px;"> Forgot Password?</a>

                                  <div class="password-input-wrapper">
                                    <input [type]="showPassword ? 'text' : 'password'" id="password" class="form-control auth-input" formControlName="passwordFormControl" placeholder="Password"
                                        style="height: 40px;padding-right: 42px; " (input)="onPasswordInput()"/>
                                    <button type="button" class="password-toggle-btn" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [title]="showPassword ? 'Hide password' : 'Show password'" (click)="togglePasswordVisibility()">
                                      <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                                    </button>
                                  </div>
                                  <div *ngIf="signInFormControls.passwordFormControl.hasError('required') && signInFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                                      Password is required.
                                  </div>
                              </div>

                              <div *ngIf="showSignInError" style="color: red;font-size: 14px; margin-top: 20px;">
                                {{signInError}}
                              </div>

                              <div class="auth-center" style="margin-top: 20px;">
                                  <button class="btn btn-primary signin-btn" type="button" (click)="onClickedSignIn()">
                                      Sign In
                                  </button>
                              </div>
                              <div class="auth-center" style="padding-top:15px;">
                                <p style="color: #14274E; font-size: 14px; font-family: 'Nunito-B';">
                                  OR
                                </p>
                              </div>
                              <div class="auth-center google-btn-wrapper" style="height: 44px;">
                                <asl-google-signin-button
                                  type="standard"
                                  size="medium"
                                  width="200"
                                  >
                                </asl-google-signin-button>
                              </div>
                                <div class="center" style="margin-top: 30px;">
                                  <p class="auth-footer"
                                     style="font-size:14px;font-family:'Nunito-B';">

                                    <span>Do not Have an Account?</span>

                                    <a (click)="onShowSignUpFormClicked()"
                                       style="
                                          cursor:pointer;
                                          color:#14274E;
                                          font-size:20px;
                                          font-family:'Nunito-B';">
                                      Sign Up
                                    </a>
                                  </p>
                                </div>
                            </div>
                    </form>
                  </div>

                    <div *ngIf="showForgotPasswordForm">
                      <form [formGroup]="forgotPasswordFormGroup">
                        <div class="form-group auth-form-container">
                          <div class="row">
                            <div class="col center" style="margin-top: 20px;">
                              <h1 class="text-center" style="font-size: 30px; padding: 0px;color: #14274e; font-family: 'Nunito-B';">
                                Forgot Password
                              </h1>
                            </div>
                          </div>
                          <div *ngIf="isEmailFilled()" style="margin-top: 20px;">
                            <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="email-address">
                                EMAIL ADDRESS
                            </label>
                            <input type="text" style="display:none" />
                            <input disabled type="text" id="email-address" class="form-control" formControlName="emailFormControl"
                                   class="form-control auth-input" />
                          </div>
                          <div *ngIf="!isEmailFilled()" style="margin-top: 20px;">
                            <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="email-address">
                                EMAIL ADDRESS
                            </label>
                            <input type="text" style="display:none" />
                            <input type="text" id="email-address" class="form-control" formControlName="emailFormControl" placeholder="Email"
                                   class="form-control auth-input" />
                            <div *ngIf="forgotPasswordFormControls.emailFormControl.hasError('required') && forgotPasswordFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                                    Email is required.
                            </div>
                            <div *ngIf="forgotPasswordFormControls.emailFormControl.hasError('invalid') && forgotPasswordFormControls.emailFormControl.touched" style="color: red;font-size: 14px;">
                              Email is invalid.
                            </div>
                          </div>
                          <div  style="margin-top: 20px;">
                            <button class="btn btn-primary left-aligned" (click)="onClickedSendOTP()" style="background-color: #14274e;width: 100px; font-size: 14px; height: 35px;">
                              Send OTP
                            </button>
                          </div>
                          <div *ngIf="sendOTPClicked && !sendOTPerror" class= "center" style="color: green;font-size: 14px; font-weight: bold;margin-top: 10px;">
                            {{messageToDisplayAfterOtpSent}}
                          </div>
                          <div *ngIf="sendOTPClicked && sendOTPerror" class= "center" style="color: red;font-size: 14px; font-weight: bold; margin-top: 10px;">
                            {{messageToDisplayAfterOtpSent}}
                          </div>

                          <div>
                            <form [formGroup]="verifyOTPFormGroup">
                              <div class="row" style="margin-top: 40px;">
                                <div class="col center">
                                    <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                                        <input id="codeBox1" type="text" formControlName="regotp0" maxlength="1" (keyup)="onKeyUpEvent(1, $event)" (focus)="onFocusEvent(1)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                                    </div>
                                    <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                                        <input id="codeBox2" type="text" formControlName="regotp1" maxlength="1" (keyup)="onKeyUpEvent(2, $event)" (focus)="onFocusEvent(2)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                                    </div>
                                    <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                                        <input id="codeBox3" type="text" formControlName="regotp2" maxlength="1" (keyup)="onKeyUpEvent(3, $event)" (focus)="onFocusEvent(3)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                                    </div>
                                    <div style="width: 50px;height: 50px;float: left;margin-right: 20px;">
                                        <input id="codeBox4" type="text" formControlName="regotp3" maxlength="1" (keyup)="onKeyUpEvent(4, $event)" (focus)="onFocusEvent(4)" style="width: inherit;height: inherit;background-color: #cbcece;border-radius: 12px;border: none;text-align: center;" />
                                    </div>
                                </div>
                              </div>
                              <label style="font-size: 14px;height: 15px; font-weight: bold;margin-top: 15px; margin-left:30px;">
                                OTP Validity : 5 Minutes
                              </label>
                              <div class="row" style="margin-left: 30px;margin-top: 20px;">
                                <div class="col">
                                    <div *ngIf="showOnClickVerifyError" style="color: red;">{{onClickVerifyError}}</div>
                                </div>
                            </div>
                              <div class="row" style="margin-left: 30px;margin-top: 34px;">
                                <div class="col">
                                    <button class="btn btn-primary" type="button" (click)="onClickVerify()" style="background-color: #14274e;width: 100px; font-size: 14px; height: 35px;">
                                        Verify
                                    </button>
                                    <button class="btn btn-primary" type="button" (click)="onClickForgotPasswordCancel()" style="background-color: #FFFF; color: #14274e; width: 100px; height: 35px; font-size: 14px;margin-left: 60px;">
                                      Cancel
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>

                        </div>
                      </form>
                    </div>

                    <div *ngIf="showResetPasswordForm">
                      <form [formGroup]="resetPasswordFormGroup">
                        <div class="form-group auth-form-container">
                          <div class="row">
                            <div class="col center" style="margin-top: 20px;">
                              <h1 class="text-center" style="font-size: 30px; padding: 0px;color: #14274e; font-family: 'Nunito-B';">
                                Reset Password
                              </h1>
                            </div>
                          </div>
                          <div style="margin-top: 20px;">
                            <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="password">
                                PASSWORD
                            </label>
                            <input type="text" style="display:none" />
                            <input type="password" formControlName="passwordFormControl" placeholder="Password"
                                   class="form-control auth-input" />
                            <div *ngIf="resetPasswordFormControls.passwordFormControl.hasError('required') && resetPasswordFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                              Password is required
                            </div>
                            <div *ngIf="resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                              Password must have at least {{minPasswordLength}} characters
                            </div>
                            <div *ngIf="resetPasswordFormControls.passwordFormControl.hasError('pattern') && !resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.passwordFormControl.touched" style="color: red;font-size: 14px;">
                              Password must contain at least 1 or more lowercase letter, uppercase letter, number and special character e.g !@#$%^&*
                            </div>
                          </div>
                          <div style="margin-top: 20px;">
                            <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;" for="reenter-password">
                                RE-ENTER PASSWORD
                            </label>
                            <input type="text" style="display:none" />
                            <input type="password" formControlName="reenterPasswordFormControl" placeholder="Password"
                                   class="form-control auth-input" />
                            <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('required') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                              Password is required
                            </div>
                            <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('minlength') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                              Password must have at least {{minPasswordLength}} characters
                            </div>
                            <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('pattern') && !resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                              Password must contain at least 1 or more lowercase letter, uppercase letter, number and special character e.g !@#$%^&*
                            </div>
                            <div *ngIf="resetPasswordFormControls.reenterPasswordFormControl.hasError('confirmedValidator') && !resetPasswordFormControls.reenterPasswordFormControl.hasError('pattern') && !resetPasswordFormControls.passwordFormControl.hasError('minlength') && resetPasswordFormControls.reenterPasswordFormControl.touched" style="color: red;font-size: 14px;">
                              Passwords did not match
                            </div>
                          </div>
                          <div class="row" style="margin-left: 45px;margin-top: 20px;">
                            <div class="col">
                                <div *ngIf="showOnClickResetPasswordError" style="color: red;">{{onClickResetPasswordError}}</div>
                            </div>
                          </div>
                          <div class="row justify-content-center">
                            <div class="col" style="margin-left: 55px;">
                                <button class="btn btn-primary auth-btn" [disabled]="resetPasswordFormGroup.invalid" type="button" (click)="onResetPasswordClicked()" style="background-color: #14274e;">
                                    Reset Password
                                </button>
                            </div>
                          </div>
                          <label style="font-size: 12px;height: 15px;padding-top: 10px;padding-bottom: 0px;color: #7c7575;font-weight: bold;" >
                              Password must have at least {{minPasswordLength}} characters
                          </label>
                          <label style="font-size: 12px;height: 15px;color: #7c7575;font-weight: bold;" >
                              Password must contain at least 1 or more lowercase letter, uppercase letter, number and special character e.g !@#$%^&*
                          </label>
                         </div>
                      </form>
                    </div>
            </div>
        </div>
        </div>
    </div>
  </ng-template>-->
